module.exports = __webpack_public_path__ + "static/media/What-This-Series-Is-About.0cf9f06a.md";